<button
  data-cy="modelOptionsMenuButton"
  class="flex h-9 w-9 items-center justify-center rounded focus:outline-none"
  [ngClass]="{
    'hover:bg-m0': isHoverM === true,
    'hover:bg-m200': isHoverM === false
  }"
  #t1="tippy"
  [tp]="templateModelOptions"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  className="my-menu"
  [tpOffset]="[0, 4]"
  (click)="clickMenu($event)"
>
  <m-dots-vertical-icon></m-dots-vertical-icon>
</button>

<ng-template #templateModelOptions>
  <div class="border-s4 bg-m0 w-64 rounded-md border-2 shadow-xl">
    <button
      data-cy="modelOptionsGoToFile"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); goToFile($event)"
      >Go to File</button
    >
    <button
      data-cy="modelOptionsGoToFile"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); showSchema($event)"
      >Schema</button
    >
  </div>
</ng-template>
